import React, { Component, PropTypes } from 'react';
import { Modal } from 'react-bootstrap';

export default class ArchiveClassModal extends Component {

  static propTypes = {
    divisionName: PropTypes.string.isRequired,
    sessionId: PropTypes.string.isRequired,
    showModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    i18n: PropTypes.func.isRequired
  }

  cancel (evt) {
    const { closeModal } = this.props;
    closeModal();
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  handleSubmit (evt) {
    const { onSubmit, sessionId, closeModal } = this.props;
    onSubmit({ sessionId });
    closeModal();
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  render () {
    const {
      showModal,
      closeModal,
      divisionName,
      i18n: _
    } = this.props;

    return (
      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>{_('Archive class?')}</Modal.Title>
        </Modal.Header>
        <form onSubmit={::this.handleSubmit}>
          <Modal.Body>

            {/* Title */}
            <div className="form-group">
              <h4>{_('Division:')} {divisionName}</h4>
            </div>
            <div className="row">
              <div className="col-sm-8 col-md-8">
                <p><strong>{_('Warning!')}</strong> {_('You can\'t undo this action.')}</p>
              </div>
            </div>

          </Modal.Body>
          <Modal.Footer>
            <button
                className="btn btn-lg"
                onClick={::this.cancel} >
              {_('Cancel')}
            </button>
            {' '}
            <button
                className="btn btn-lg btn-danger"
                type="submit" >
              {_('Archive')}
            </button>
          </Modal.Footer>

        </form>
      </Modal>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/dashboard/archiveClassModal.jsx